import React, { useRef, useState } from "react";

import NoDataFound from "../../../../Extra/NoDataFound";
import {
  secondsToHHMM,
  secondsToTime,
  timeToSeconds,
} from "../../../../Utilitie";
import {
  columnWidths,
  tableHeadForExcel,
} from "../../../../InsertData/blockData/UpdateHalper";
import DownloadExcelFromData from "../../../../Extra/DownloadExcelFromData";
const tableHead = [
  "Sno",
  "reportDate",
  "section",
  "Direction",
  "From_Station",
  "To_Station",
  "Section_Yard",
  "Corridore",
  "Department",
  "Type",
  "Block_Type",
  "No_Of_Demand_By_Engg",
  "Engg_Demand",
  "No_Of_Demand_Agreed_GIVEN",
  "Agreed_Demand",
  "GrantedFrom",
  "GrantedTo",
  "Granted_Duration",
  "Availed_Not",
  "Availed_From",
  "Availed_To",
  "Availed",
  "Burst",
  "Burst_Duration",
  "Actual_Output_in_Meter",
  "Actual_Output",
  "Remarks",
  "Reason",
  "Rolling_Block",
];
const MasterTable = ({ data }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 50;
  const indexOfLastRow = currentPage * rowsPerPage;

  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const sortedData = data.sort(
    (a, b) => new Date(a.reportDate) - new Date(b.reportDate),
  );

  const currentData = sortedData.slice(indexOfFirstRow, indexOfLastRow);

  const totalPages = Math.ceil(data.length / rowsPerPage);
  const tableRef = useRef();
  data.forEach((obj) => {
    for (const key in obj) {
      if (key === "reportDate") {
        obj[key] = obj.reportDate.slice(0, 10);
      }
      if (key === "Burst_Duration") {
        obj[key] = secondsToHHMM(
          timeToSeconds(obj.Availed) - timeToSeconds(obj.Granted_Duration),
        ).slice(0, 5);
      }
    }
  });

  const availedCount = sortedData.reduce(
    (sum, item) => sum + (item.Availed_Not === "AVAILED" ? 1 : 0),
    0,
  );

  const agreedCount = sortedData.reduce(
    (sum, item) => sum + (Number(item.No_Of_Demand_Agreed_GIVEN) || 0),
    0,
  );

  const totalRow = {
    Sno: "TOTAL",
    reportDate: "",
    section: "",
    Direction: "",
    From_Station: "",
    To_Station: "",
    Section_Yard: "",
    Corridore: "",
    Department: "",
    Type: "",
    Block_Type: "",

    No_Of_Demand_By_Engg: sortedData.reduce(
      (sum, item) => sum + (Number(item.No_Of_Demand_By_Engg) || 0),
      0,
    ),

    Engg_Demand: secondsToTime(
      sortedData.reduce(
        (sum, item) => sum + (timeToSeconds(item.Engg_Demand) || 0),
        0,
      ),
    ),

    No_Of_Demand_Agreed_GIVEN: agreedCount,

    Agreed_Demand: secondsToTime(
      sortedData.reduce(
        (sum, item) => sum + (timeToSeconds(item.Agreed_Demand) || 0),
        0,
      ),
    ),

    GrantedFrom: "",
    GrantedTo: "",

    Granted_Duration: secondsToTime(
      sortedData.reduce(
        (sum, item) => sum + (timeToSeconds(item.Granted_Duration) || 0),
        0,
      ),
    ),

    // Match the table footer: AVAILED / NOT AVAILED
    Availed_Not: `${availedCount} / ${Math.max(0, agreedCount - availedCount)}`,

    Availed_From: "",
    Availed_To: "",

    Availed: secondsToTime(
      sortedData.reduce(
        (sum, item) => sum + (timeToSeconds(item.Availed) || 0),
        0,
      ),
    ),

    Burst: sortedData.reduce(
      (sum, item) => sum + (item.Burst === "BURST" ? 1 : 0),
      0,
    ),

    Burst_Duration: secondsToTime(
      sortedData.reduce((sum, item) => {
        const availed = timeToSeconds(item.Availed);
        const granted = timeToSeconds(item.Granted_Duration);

        return sum + (item.Burst === "BURST" ? Math.abs(availed - granted) : 0);
      }, 0),
    ).slice(0, 5),

    Actual_Output_in_Meter: sortedData.reduce(
      (sum, item) => sum + (Number(item.Actual_Output_in_Meter) || 0),
      0,
    ),

    Actual_Output: "",
    Remarks: "",
    Reason: "",
    Rolling_Block: "",
  };

  const excelData = [
    ...sortedData.map((item, index) => ({
      ...item,
      No: index + 1,
      reportDate: item.reportDate?.slice(0, 10),

      // Same display logic as the React table
      Availed_Not: item.Availed_Not === "AVAILED" ? 1 : 0,

      Burst_Duration: secondsToHHMM(
        timeToSeconds(item.Availed) - timeToSeconds(item.Granted_Duration),
      ).slice(0, 5),
    })),
    totalRow,
  ];

  return (
    <div className="">
      <div className="row">
        <div className="bg-dark text-white p-1">
          <h5>Customize Report</h5>
          <h6 className="" style={{ color: "gray", fontWeight: "bold" }}>
            (Data count {data?.length})
          </h6>
        </div>
      </div>
      {data.length > 0 ? (
        <div className="">
          <div
            className="table-responsive mt-2  "
            style={{ maxHeight: "700px", overflow: "auto" }}
          >
            <table
              className="table table-hover table-striped "
              ref={tableRef}
              style={{ fontSize: "13px" }}
            >
              <thead className="sticky-top table-dark" style={{ zIndex: 2 }}>
                <tr>
                  <th className="align-middle">No</th>
                  {tableHead.map((head, i) => {
                    return (
                      <th
                        key={i}
                        className="text-wrap align-middle"
                        style={{ width: columnWidths[head] }}
                      >
                        {head === "Sno"
                          ? "ID"
                          : head.replace(/_/g, " ").toUpperCase()}
                      </th>
                    );
                  })}
                </tr>
              </thead>
              <tbody>
                {currentData.map((obj, i) => {
                  return (
                    <tr key={i}>
                      <td>{indexOfFirstRow + i + 1}</td>

                      {tableHead.map((key, b) => {
                        return (
                          <td
                            className="text-wrap"
                            key={b}
                            style={{ width: columnWidths[key] }}
                          >
                            {key === "Availed_Not"
                              ? obj[key] === "AVAILED"
                                ? 1
                                : 0
                              : obj[key]}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
              <tfoot className="sticky-bottom" style={{ zIndex: 2 }}>
                <tr className="table-dark">
                  <td className="" colSpan={12} rowSpan={2}>
                    Total
                  </td>
                  <td
                    rowSpan={2}
                    style={{ width: columnWidths.No_Of_Demand_By_Engg }}
                  >
                    {data.reduce(
                      (sum, item) => sum + (item.No_Of_Demand_By_Engg || 0),
                      0,
                    )}
                  </td>
                  <td rowSpan={2} style={{ width: columnWidths.Engg_Demand }}>
                    {secondsToTime(
                      data.reduce(
                        (sum, item) =>
                          sum + (timeToSeconds(item.Engg_Demand) || 0),
                        0,
                      ),
                    )}
                  </td>
                  <td
                    rowSpan={2}
                    style={{ width: columnWidths.No_Of_Demand_Agreed_GIVEN }}
                  >
                    {data.reduce(
                      (sum, item) =>
                        sum + (item.No_Of_Demand_Agreed_GIVEN || 0),
                      0,
                    )}
                  </td>
                  <td rowSpan={2} style={{ width: columnWidths.Agreed_Demand }}>
                    {secondsToTime(
                      data.reduce(
                        (sum, item) =>
                          sum + (timeToSeconds(item.Agreed_Demand) || 0),
                        0,
                      ),
                    )}
                  </td>
                  <td
                    rowSpan={2}
                    style={{ width: columnWidths.GrantedFrom }}
                  ></td>
                  <td
                    rowSpan={2}
                    style={{ width: columnWidths.GrantedTo }}
                  ></td>
                  <td
                    rowSpan={2}
                    style={{ width: columnWidths.Granted_Duration }}
                  >
                    {secondsToTime(
                      data.reduce(
                        (sum, item) =>
                          sum + (timeToSeconds(item.Granted_Duration) || 0),
                        0,
                      ),
                    )}
                  </td>
                  <td>
                    {" "}
                    {data.reduce(
                      (sum, item) =>
                        sum +
                        (Number(item.Availed_Not === "AVAILED" ? 1 : 0) || 0),
                      0,
                    )}
                    /
                    {data.reduce(
                      (sum, item) =>
                        sum + (item.No_Of_Demand_Agreed_GIVEN || 0),
                      0,
                    ) -
                      data.reduce(
                        (sum, item) =>
                          sum +
                          (Number(item.Availed_Not === "AVAILED" ? 1 : 0) || 0),
                        0,
                      ) >
                    0
                      ? data.reduce(
                          (sum, item) =>
                            sum + (item.No_Of_Demand_Agreed_GIVEN || 0),
                          0,
                        ) -
                        data.reduce(
                          (sum, item) =>
                            sum +
                            (Number(item.Availed_Not === "AVAILED" ? 1 : 0) ||
                              0),
                          0,
                        )
                      : 0}
                  </td>
                  <td
                    rowSpan={2}
                    style={{ width: columnWidths.Availed_From }}
                  ></td>
                  <td
                    rowSpan={2}
                    style={{ width: columnWidths.Availed_To }}
                  ></td>
                  <td rowSpan={2} style={{ width: columnWidths.Availed }}>
                    {secondsToTime(
                      data.reduce(
                        (sum, item) => sum + (timeToSeconds(item.Availed) || 0),
                        0,
                      ),
                    )}
                  </td>
                  <td style={{ width: columnWidths.Burst }}>
                    {" "}
                    {data.reduce(
                      (sum, item) =>
                        sum + (Number(item.Burst === "BURST" ? 1 : 0) || 0),
                      0,
                    )}
                  </td>
                  <td
                    rowSpan={2}
                    style={{ width: columnWidths.Burst_Duration }}
                  >
                    {secondsToTime(
                      data.reduce((sum, item) => {
                        let a = timeToSeconds(item.Availed);
                        let b = timeToSeconds(item.Granted_Duration);

                        return (
                          sum +
                          (Number(
                            item.Burst === "BURST"
                              ? a > b
                                ? a - b
                                : b - a
                              : 0,
                          ) || 0)
                        );
                      }, 0),
                    ).slice(0, 5)}{" "}
                  </td>
                  <td
                    rowSpan={2}
                    style={{ width: columnWidths.Actual_Output_in_Meter }}
                  >
                    {data.reduce(
                      (sum, item) =>
                        sum + (Number(item.Actual_Output_in_Meter) || 0),
                      0,
                    )}
                  </td>
                  <td
                    rowSpan={2}
                    style={{ width: columnWidths.Actual_Output }}
                  ></td>
                  <td rowSpan={2} style={{ width: columnWidths.Remarks }}></td>
                  <td
                    rowSpan={2}
                    style={{ width: columnWidths.Rolling_Block }}
                  ></td>
                  <td rowSpan={2} style={{ width: columnWidths.Delete }}></td>
                </tr>
              </tfoot>
            </table>
          </div>
          <div className="d-flex justify-content-between align-items-center my-3">
            <button
              className="btn btn-sm btn-outline-primary"
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((prev) => prev - 1)}
            >
              Previous
            </button>
            <span>
              Page {currentPage} of {totalPages}
              <br />
              (Data count {data?.length})
            </span>
            <div className="">
              <div className="d-flex">
                <button
                  className="btn btn-sm btn-outline-primary me-1"
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage((prev) => prev + 1)}
                >
                  Next
                </button>
                <DownloadExcelFromData
                  data={excelData}
                  columnOrder={tableHeadForExcel}
                  fileName={`Block Data `}
                />
              </div>
              <span className="text-secondary">
                {" "}
                now excel have totals too{" "}
              </span>
            </div>
          </div>
        </div>
      ) : (
        <NoDataFound />
      )}
    </div>
  );
};
export default MasterTable;
